// Official hierarchy options from Commission Implementing Regulation (EU) 2024/2956
// Field b_01.02.0050: Hierarchy of the financial entity within the group
export const HIERARCHY_LEVEL_OPTIONS = [
  "The financial entity is the ultimate parent undertaking in the consolidation",
  "The financial entity is the parent undertaking of a sub-consolidated part in the consolidation",
  "The financial entity is a subsidiary in the consolidation and is not a parent undertaking of a sub-consolidated part",
  "The financial entity is not part of a group",
  "The financial entity is a service provider to which the financial entity (or the third-party service provider acting on its behalf) is outsourcing all its operational activities"
] as const;

export type HierarchyLevel = typeof HIERARCHY_LEVEL_OPTIONS[number];
